
/*
-------- Treeview 
*/

$(function() {
  $("ul.portal-articles .portal-articles-caret").on('click', function() {
    var li = $(this).parents("li");
    var nested = li.find('.nested').first();
    li.toggleClass("caret-down");
    li.toggleClass("caret-up");

  });
});

/*
-------- Report pdf progress
*/

$(function() {
  $(".portal-articles a.pdf-link").on('click', function() {
    var reportProgress = $(this).data("report-progress");
    if (reportProgress == "1") {
      id = $(this).data("article-id");
      var url = getPortalStatusUrl(id, 100);
      $.getJSON(url, function(result){   });
      var progressBar = $('#progress-wrapper-' + id + " .progress-bar");
      progressBar.attr("aria-valuenow", "100")
      progressBar.css("width", "100%")
      var thumbs = $('#thumbs-up-wrapper-' + id + ' .fa-thumbs-up');
      thumbs.show();
  
      calculateAverageProgress();
      calculateNewContentIndicatorOnPortalArticles();
    }
  });
});


/*
-------- Open pdf:s in new window in desktops and tablets
*/

$(function() {
  if (screen.width > 700) {
    $('.portal-articles a.pdf-link').each(function() {
      $(this).attr('target', '_blank')
    });
  }
});

/*
--------- Report Vimeo progress 
*/

$(function() {
  $("section.portal").on('show.bs.modal', ".modal.portal-vimeo", function (event) {
    var link = $(event.relatedTarget) // Button that triggered the modal

    var id = link.data("article-id");
    var iframe = document.querySelector('#iframe-article-' + id);
    if ($(iframe).attr("src") == "") {
      var url = $(iframe).data("src");
      $(iframe).attr("src",url);
    }
    var player = new Vimeo.Player(iframe);
    var reportAt = 0;

    player.play();
    player.on('timeupdate', function(data){
      if ((data.percent * 100) >= reportAt) {
        do {
          reportAt = reportAt + 10;
        } while (reportAt < (data.percent * 100));
        reportVimeoProgress(id, reportAt, link)
      }
        
    });
  });
});


function reportVimeoProgress(id, status, link) {
  var reportProgress = link.data("report-progress");
  if (reportProgress == "1") {
    var url = getPortalStatusUrl(id, status);
    $.getJSON(url, function(result){   });
    var progressBar = $('#progress-wrapper-' + id + " .progress-bar");
    oldProgress = progressBar.attr("aria-valuenow");
    if (status > oldProgress) {
      progressBar.attr("aria-valuenow", status)
      progressBar.css("width", status + "%")
      if (status == 100) {
        var thumbs = $('#thumbs-up-wrapper-' + id + ' .fa-thumbs-up');
        thumbs.show();
      }
      calculateAverageProgress();
      calculateNewContentIndicatorOnPortalArticles();
    }
    
  }

}

function getPortalStatusUrl(id, status) {
  if ($(".portal-articles").hasClass("carbonhandv3")) {
    return '/carbonhand3-status/' + id + '.json?status=' + status;
  }
  return '/carbonhand2-status/' + id + '.json?status=' + status;
}
/*
-------- PAUSE VIMEO WHEN CLOSING MODAL
*/

$(function() {
  $("section.portal").on('hidden.bs.modal', '.modal.portal-vimeo', function (e) {
    var iframe = $(this).find('iframe');
    var player = new Vimeo.Player(iframe);
    player.pause();

  });
});

/*
-------- Calculate average progress
*/

$(function() {
  calculateAverageProgress();

});


function calculateAverageProgress() {
  jQuery('.portal-articles .progress-wrapper.structure').each(function() {
    var parent = jQuery(this).parent("li");
    var count = 0;
    var sum = 0;

    parent.find(".progress-wrapper.entry .progress-bar").each(function() {
      count = count + 1
      sum += parseInt( jQuery(this).attr("aria-valuenow") ); //don't forget to add the base
    });
 
    var avg = sum/count;
    var progressBar = jQuery(this).find(".progress-bar").first();
    progressBar.attr("aria-valuenow", avg);
    progressBar.css("width", avg + "%");
    if (avg == 100) {
      var thumbs = parent.find(".fa-thumbs-up").first();
      thumbs.show();
    }
  });
  //setTimeout(calculateAverageProgress(), 5000);
}

/*
-------- CALCULATE NEW-CONTENT-INDICATOR ON PORTAL-ARTICLES
*/

$(function() {
  calculateNewContentIndicatorOnPortalArticles();

});

function calculateNewContentIndicatorOnPortalArticles() {
  jQuery('.portal-articles .progress-wrapper.entry.new').each(function() {
    var progressBar = jQuery(this).find(".progress-bar").first();
    var completed = progressBar.attr("aria-valuenow");
    var li = jQuery(this).parent("li");
    var indicator = li.find(".new-content-small-indicator").first()
    if (completed == 0) {
      indicator.removeClass("hidden");
    } else {
      indicator.addClass("hidden");
    }
  });
  jQuery('.portal-articles .caret-up, .portal-articles .caret-down').each(function() {
    var indicators = jQuery(this).find(".new-content-small-indicator:not(.hidden)");
    var unredCount = indicators.length;
    var newContentIndicator = jQuery(this).find(".new-content-indicator").first();
    newContentIndicator.text(unredCount);
    if (unredCount > 0) {
      newContentIndicator.removeClass("hidden");
    } else {
      newContentIndicator.addClass("hidden");
    }
  });
  
  //setTimeout(calculateAverageProgress(), 5000);
}

/*
-------- CALCULATE NEW-CONTENT-INDICATOR ON PORTAL-INDEX
*/

$(function() {
  $('.portal-index li').each(function() {
    var progressWrapper = $(this).find(".progress-wrapper").first();
    var unreadCount = progressWrapper.data('new-content');
    if (unreadCount > 0) {
      var newContentIndicator = $(this).find(".new-content-indicator").first();
      newContentIndicator.text(unreadCount);
      newContentIndicator.removeClass("hidden");
    }
  });
});

/*
-------- TABLE SORT TO USERS PAGE
*/

$(function() {
  if ($('#portal-users').length) {
    new Tablesort(document.getElementById('portal-users'), {
      descending: true
    });
  }
});

/*
-------- FILTER IN USERS PAGE
*/

$(function() {
  $("#portal-companies-filter select").on('change', function() {
    if ($(this).val() != "") {
      $("#portal-companies-filter").submit();
    }
  });
});
